/**
 * Sistema de movimento compartilhado do site.
 *
 * Existiam dois padrões de animação convivendo sem se falar: a landing
 * page usava useScrollReveal (IntersectionObserver + classe CSS
 * condicional) e o funil usava `animate-fade-in-up` com delay calculado
 * na mão em cada `style={{ animationDelay: ... }}`. Cada página que
 * pedisse animação nova reinventaria um dos dois, ou um terceiro jeito.
 *
 * Este arquivo é a fonte única: os componentes em components/motion/
 * consomem essas variants, e todo o site (landing, wizard, formulário)
 * passa a usar a mesma curva de entrada e o mesmo espaçamento de
 * stagger, só variando o que anima.
 *
 * A curva EASE_BRAND replica o cubic-bezier(0.23, 1, 0.32, 1) que já
 * era usado nos hovers de card espalhados pelo código — não é uma
 * curva nova, é a que já existia formalizada num só lugar.
 */

export const EASE_BRAND = [0.23, 1, 0.32, 1];

export const fadeInUp = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE_BRAND } },
};

export const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5, ease: 'easeOut' } },
};

export const scaleIn = {
    hidden: { opacity: 0, scale: 0.92 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: EASE_BRAND } },
};

/** Container que orquestra a entrada escalonada dos filhos. */
export const staggerContainer = (staggerDelay = 0.1, startDelay = 0) => ({
    hidden: {},
    visible: {
        transition: { staggerChildren: staggerDelay, delayChildren: startDelay },
    },
});

/** Item filho de um staggerContainer — herda fadeInUp. */
export const staggerItem = fadeInUp;

/** Micro-interação padrão de botão: leve elevação no hover, leve compressão no clique. */
export const buttonTap = {
    whileHover: { y: -2, transition: { duration: 0.2, ease: EASE_BRAND } },
    whileTap: { scale: 0.97, y: 0 },
};

/** Mesma ideia, mais discreta — para botões secundários/links. */
export const buttonTapSubtle = {
    whileTap: { scale: 0.98 },
};
